<template>
<div class="nav-bar">
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center pt-4">
      <div class="col-3 d-flex justify-content-start align-items-center">
        <div
          id="hamburger-1"
          class="hamburger"
          :class="[isActive ? 'is-active' : '']"
          @click="menuToggle"
        >
          <span class="line" />
          <span class="line" />
          <span class="line" />
        </div>
      </div>
      <div class="col-6 d-flex justify-content-center align-items-center align-start">
        <!-- <router-link v-if="!logoRedirect" to="/" class="logo-link"> -->
        <router-link to="/" class="logo-link" :class="{ home : isHome }">
          <img class="logo" alt="logo" src="../assets/logo.svg" @click="hide" />
        </router-link>
        <!-- <a v-else href="https://www.dgc.ca/en/ontario/">
          <img class="logo" alt="logo" src="../assets/logo.svg" @click="hide()" />
        </a> -->
      </div>
      <div class="col-3 d-flex justify-content-end align-start">
        <div class="search-container">
          <img alt="search" class="search-icon" src="../assets/search.svg" @click="searchToggle" />
        </div>
      </div>
      <Menu
        class="menu"
        :class="[isActive ? 'is-active' : '']"
        :is-active="isActive"
        @close="hideMenu"
      />
      <search 
        :class="`search-bar ${searchBool ? 'is-active' : ''}`"
        :search-active="searchBool" 
        @close="hideSearch" />
    </div>
  </div>
</div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Search from "@/components/Search.vue";

export default {
  name: "Navigation",
  components: {
    Menu,
    Search
  },
  data() {
    return {};
  },
  computed: {
    searchBool() {
      return this.$store.getters.searchStatus;
    },
    isActive() {
      return this.$store.getters.menuStatus;
    },
    // logoRedirect() {
    //  return this.$route.name === 'home';
    // }
    isHome() {
      return this.$route.name === 'home';
    }
  },
  methods: {
    menuToggle() {
      this.$store.commit("menuToggle");
      this.searchBool ? this.$store.commit("searchStatusChange", this.searchBool) : ''
        
    },
    searchToggle() {
      this.$store.commit("searchStatusChange", this.searchBool);
      // this.$refs.searchInput.focus()
      // console.log(this.$refs.searchInput)
      this.isActive ? this.$store.commit("menuToggle") : ''
    },
    hide() {
      this.$store.commit("searchStatusHide");
      this.$store.commit("hideMenu");
    },
    hideSearch() {
      this.$store.commit("searchStatusHide");
    },
    hideMenu() {
      this.$store.commit("hideMenu");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}
.z-index-99 {
  z-index: 99;
}

.search-container {
  // padding-top: 40px;
  // padding-right: 40px;
  // position: fixed;
  // right: 0;
  // top: 0;
  z-index: 99;
}
.logo-link {
  z-index: 99;
}

.logo-link.home {
 cursor: default;
}

.search-icon {
  width: 50px;
  cursor: pointer;
  margin-right: 10px;
  opacity: 1;
  filter: drop-shadow(3px 3px 5px rgba(0,0,0,0.3));
}

.menu {
  transform: translate(-100vw);
  transition: all 0.35s ease-in-out;
}

.menu.is-active {
  transform: translate(0px);
}

.search-bar {
  transform: translate(100vw);
  transition: all 0.35s ease-in-out;
}

.search-bar.is-active {
  transform: translate(0);
  width: 100vw;
  height: 100vh;
}

/* ALL */

.logo {
  width: 120px;
}

.hamburger {
  z-index: 99;
  margin-left: 20px;
}

.hamburger .line {
  width: 40px;
  height: 4px;
  background-color: #ecf0f1;
  display: block;
  margin: 8px auto;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  border-radius: 20px;
  opacity: 1;
  box-shadow: 3px 3px 5px rgba(0,0,0,0.3);
}

.hamburger:hover {
  cursor: pointer;
}

/* ONE */

#hamburger-1.is-active .line:nth-child(2) {
  opacity: 0;
}

#hamburger-1.is-active .line:nth-child(1) {
  -webkit-transform: translateY(12px) rotate(45deg);
  -ms-transform: translateY(12px) rotate(45deg);
  -o-transform: translateY(12px) rotate(45deg);
  transform: translateY(12px) rotate(45deg);
  opacity: 1;
}

#hamburger-1.is-active .line:nth-child(3) {
  -webkit-transform: translateY(-13px) rotate(-45deg);
  -ms-transform: translateY(-13px) rotate(-45deg);
  -o-transform: translateY(-13px) rotate(-45deg);
  transform: translateY(-13px) rotate(-45deg);
  opacity: 1;
}

/* MOBILE */

@media only screen and (max-width: 600px) {
  h1 {
    font-size: 65px;
    line-height: 62px;
  }
  .logo {
    width: 120px;
    padding-left: 10px;
    transform: scale(0.7);
  }
  .hamburger {
    margin-left: 10px;
    transform: scale(0.75);
  }
  .search-icon {
    margin-right: 0px;
    transform: scale(0.75);
  }
}
</style>
